export const MIN_PLAYER_USERNAME_LENGTH = 5;
export const MAX_PLAYER_USERNAME_LENGTH = 20;
export const PROFILE_OG_PLACEHOLDER_IMAGE = 'https://cdn.app.veo.co/images/Veo-logo-green.png';
